/** GSM 03.38 basic character set (each costs 1 septet). */
const GSM_BASIC = new Set(
  `@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà`,
)

/** GSM 03.38 extension table (each costs 2 septets: escape + char). */
const GSM_EXTENDED = new Set(`^{}\\[~]|€`)

export type SmsSegmentInfo = {
  /**
   * Billing units, NOT visible characters: GSM septets (extended chars like €
   * cost 2) or UTF-16 code units for UCS-2 (emoji cost 2). An emoji the user
   * sees as one character counts as two here.
   */
  units: number
  segments: number
  encoding: `GSM-7` | `UCS-2`
}

/**
 * Character/segment accounting for an SMS body. GSM-7 fits 160 chars in a
 * single segment and 153 per segment when concatenated; one non-GSM character
 * (emoji, smart quote) re-encodes the whole message as UCS-2 at 70/67.
 */
export function smsSegments(text: string): SmsSegmentInfo {
  let units = 0
  for (const ch of text) {
    if (GSM_BASIC.has(ch)) units += 1
    else if (GSM_EXTENDED.has(ch)) units += 2
    else {
      // UCS-2 counts UTF-16 code units, so astral chars (emoji) cost 2.
      const ucs2Units = text.length
      const segments = ucs2Units <= 70 ? 1 : Math.ceil(ucs2Units / 67)
      return { units: ucs2Units, segments, encoding: `UCS-2` }
    }
  }
  const segments = units === 0 ? 0 : units <= 160 ? 1 : Math.ceil(units / 153)
  return { units, segments, encoding: `GSM-7` }
}
